import { Controller } from "@hotwired/stimulus"

// Shows the recipient picker only when "notify users" is checked.
export default class extends Controller {
  static targets = ["checkbox", "recipients"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasRecipientsTarget || !this.hasCheckboxTarget) return

    this.recipientsTarget.classList.toggle("hidden", !this.checkboxTarget.checked)
  }
}
